import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  findCurrent() {
    return Api()
      .get('/mandatsetting/current')
      .then((res) => this.formatRes(res.data));
  },
  update(mandatSetting) {
    return Api()
      .put('/mandatsetting/' + mandatSetting.id, mandatSetting)
      .then((res) => this.formatRes(res.data));
  },
  formatRes(e) {
    return e;
  },
};
